const { buildWhatsappLink } = require("./constants");

const makeCta = (message, source) => ({
  label: "Pedir diagnóstico gratuito",
  href: buildWhatsappLink(message, source),
});

const localServicePages = [
  {
    path: "/criacao-de-sites-aveiro",
    city: "Aveiro",
    service: "Criação de sites",
    title: "Criação de sites Aveiro | BezierClick",
    description:
      "Criação de sites em Aveiro para empresas que precisam de presença digital profissional, SEO local, WhatsApp e páginas preparadas para gerar contactos.",
    h1: "Criação de sites em Aveiro para empresas",
    localContext:
      "Aveiro reúne empresas industriais, serviços locais, comércio, turismo e negócios B2B que competem tanto pela confiança regional como por procura nacional. Um site bem estruturado ajuda a explicar serviços, aparecer nas pesquisas certas e transformar visitas em contactos comerciais.",
    businessFit:
      "Esta página é pensada para empresas de Aveiro que precisam deixar de depender apenas de indicação, redes sociais ou presença digital antiga, criando uma base comercial clara para Google, propostas, campanhas e contacto direto.",
    services: ["Website empresarial", "Landing pages", "SEO local Aveiro", "Integração WhatsApp", "Google Analytics", "Search Console"],
    faq: [
      {
        question: "A BezierClick cria sites para empresas em Aveiro?",
        answer: "Sim. Trabalhamos com empresas em Aveiro e em Portugal, criando websites orientados a clareza comercial, SEO e pedidos de contacto.",
      },
      {
        question: "O site pode ajudar a aparecer em pesquisas locais?",
        answer: "Sim. A estrutura pode incluir SEO local, metadata, conteúdo regional e preparação para reforçar pesquisas como criação de sites Aveiro.",
      },
      {
        question: "Também fazem manutenção depois da publicação?",
        answer: "Sim. O website pode evoluir para manutenção, automações, SEO contínuo e acompanhamento Tech Partner.",
      },
    ],
    cta: makeCta(
      "Olá! Quero um diagnóstico gratuito para criação de site em Aveiro.",
      "local_criacao_sites_aveiro"
    ),
  },
  {
    path: "/criacao-de-sites-vagos",
    city: "Vagos",
    service: "Criação de sites",
    title: "Criação de sites Vagos | BezierClick",
    description:
      "Criação de sites em Vagos para negócios locais e empresas que querem melhorar presença no Google, captar contactos e comunicar serviços com clareza.",
    h1: "Criação de sites em Vagos para negócios locais",
    localContext:
      "Vagos tem uma realidade empresarial próxima, com comércio, serviços, indústria, alojamento, restauração e empresas que precisam ser encontradas por clientes da região. Um website profissional ajuda a transformar procura local em contacto e credibilidade.",
    businessFit:
      "A BezierClick ajuda negócios de Vagos a criar uma presença digital simples de perceber, rápida em mobile e preparada para visitantes que chegam pelo Google, WhatsApp, redes sociais ou recomendações.",
    services: ["Website profissional", "Página de serviços", "SEO local Vagos", "Contacto WhatsApp", "Formulários", "Publicação"],
    faq: [
      {
        question: "Uma empresa pequena em Vagos precisa de website?",
        answer: "Quando clientes pesquisam serviços antes de contactar, um website ajuda a criar confiança e organizar informação que redes sociais nem sempre apresentam bem.",
      },
      {
        question: "O conteúdo será igual ao de outras cidades?",
        answer: "Não. A página deve refletir contexto, serviços e procura real de Vagos, sem duplicar texto apenas trocando o nome da localidade.",
      },
      {
        question: "O site pode incluir WhatsApp?",
        answer: "Sim. Os CTAs podem abrir conversas no WhatsApp com mensagens contextualizadas e tracking de cliques.",
      },
    ],
    cta: makeCta(
      "Olá! Quero um diagnóstico gratuito para criação de site em Vagos.",
      "local_criacao_sites_vagos"
    ),
  },
  {
    path: "/software-a-medida-aveiro",
    city: "Aveiro",
    service: "Software à medida",
    title: "Software à medida Aveiro | BezierClick",
    description:
      "Software à medida em Aveiro para empresas que precisam substituir Excel, organizar processos, criar portais, dashboards e sistemas internos.",
    h1: "Software à medida em Aveiro para processos empresariais",
    localContext:
      "Empresas de Aveiro ligadas a serviços, indústria, equipas comerciais e operações internas muitas vezes crescem com processos espalhados por Excel, email e ferramentas que já não acompanham a equipa. Software à medida pode organizar esse trabalho sem impor uma plataforma genérica.",
    businessFit:
      "A BezierClick transforma processos específicos de empresas em Aveiro em sistemas web, portais internos, CRM simples e dashboards que reduzem trabalho manual e melhoram visibilidade operacional.",
    services: ["CRM interno", "Portais empresariais", "Dashboards", "Gestão de processos", "Relatórios", "Integrações"],
    faq: [
      {
        question: "Quando faz sentido criar software à medida?",
        answer: "Quando o processo é central para a empresa e ferramentas prontas criam trabalho extra, duplicação ou falta de controlo.",
      },
      {
        question: "O software pode começar por uma versão pequena?",
        answer: "Sim. O ideal é começar pelo processo mais crítico, validar com utilizadores e evoluir por etapas.",
      },
      {
        question: "A solução pode integrar ferramentas atuais?",
        answer: "Sim. Avaliamos APIs, exportações e fluxos existentes para ligar o novo sistema ao que a empresa já utiliza.",
      },
    ],
    cta: makeCta(
      "Olá! Quero um diagnóstico gratuito para software à medida em Aveiro.",
      "local_software_aveiro"
    ),
  },
  {
    path: "/automacao-empresarial-aveiro",
    city: "Aveiro",
    service: "Automação empresarial",
    title: "Automação empresarial Aveiro | BezierClick",
    description:
      "Automação empresarial em Aveiro para reduzir tarefas repetitivas, organizar leads, ligar ferramentas e acelerar operações comerciais ou administrativas.",
    h1: "Automação empresarial em Aveiro para equipas mais eficientes",
    localContext:
      "Em Aveiro, muitas PMEs combinam atendimento próximo, processos administrativos e equipas enxutas. Quando pedidos chegam por formulário, email ou WhatsApp, a automação ajuda a responder mais rápido, encaminhar informação e reduzir tarefas repetitivas.",
    businessFit:
      "A BezierClick cria automações para empresas em Aveiro que querem melhorar seguimento comercial, notificações internas, sincronização de dados e organização de processos sem contratar uma equipa técnica interna.",
    services: ["Automação de leads", "Follow-up", "Notificações", "WhatsApp", "CRM", "Integrações"],
    faq: [
      {
        question: "Que tarefas podem ser automatizadas?",
        answer: "Captação de contactos, notificações, envio de emails, registo em CRM, pedidos internos e sincronização entre ferramentas.",
      },
      {
        question: "Automação exige mudar todas as ferramentas?",
        answer: "Não necessariamente. Muitas automações ligam ferramentas existentes e melhoram o fluxo sem substituir tudo.",
      },
      {
        question: "Como medir se a automação resultou?",
        answer: "Definimos objetivos como tempo poupado, menos erros, resposta mais rápida ou melhor seguimento de oportunidades.",
      },
    ],
    cta: makeCta(
      "Olá! Quero um diagnóstico gratuito para automação empresarial em Aveiro.",
      "local_automacao_aveiro"
    ),
  },
];

const getLocalServicePageByPath = (path) =>
  localServicePages.find((page) => page.path === path) || null;

module.exports = {
  localServicePages,
  getLocalServicePageByPath,
};
